import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 10 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.66887 20.62C8.52385 19.9345 8.33552 19.517 8.09713 19.0598C7.88138 18.6457 7.68033 18.3074 7.64775 17.8202C7.45148 14.9038 6.73153 9.80517 6.61274 5.66869C6.49791 1.66166 5.64645 0.874398 5.2237 0.912615C4.75526 0.955131 4.71275 2.70498 4.22404 5.37489C3.69958 8.24163 3.4743 9.82093 3.17432 11.845C2.84057 14.0988 2.82825 15.3084 2.6137 16.7893C2.49371 17.6167 2.40908 18.1613 2.29942 18.5778C2.16671 19.0813 2.08923 19.3183 1.82382 19.8509C1.31168 20.8785 0.888929 25.3684 1.66132 26.7156C2.12976 27.5325 2.42298 27.8817 3.09962 28.1105C3.52595 28.2543 4.46362 28.8949 5.1792 28.9107C5.85226 28.9259 6.40255 28.6709 7.36446 28.3365C8.02004 28.1086 8.39035 27.9557 8.85204 27.2439C9.61132 26.0726 9.08407 22.581 8.66887 20.6205V20.62Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
